import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';
import DashboardLayout from './dashboard';
import ErrorLayout from './error';
import StandalonePublisherOnboarding from "../components/PublisherOnboarding/StandalonePublisherOnboarding";
import ConfirmPublisher from "../components/PublisherOnboarding/ConfirmPublisher";
import { checkTokenAccess, getOnboardingStatus } from "./service";

import loadable from '@loadable/component';
const AuthBasicLayout = loadable(() => import('./auth'));

const Layout = () => {
  const [loading, setLoading] = useState(true);
  const [onboardingCompleted, setOnboardingCompleted] = useState(
    localStorage.getItem("onboarding_completed") || "true"
  );

  useEffect(() => {
    AuthBasicLayout.preload();

    const currentPath = window.location.pathname;
    const authPaths = ["/ForgotPassword", "/login", "/pub/forgotPassword", "/confirm-publisher"];

    if (
      localStorage.getItem("isLoged") === "true" &&
      !authPaths.includes(currentPath) &&
      !currentPath.startsWith('/reset/')
    ) {
      checkTokenAccess()
        .then(async (res) => {
          if (res && res.success) {
            const currentStatus = localStorage.getItem("onboarding_completed");
            if (currentStatus !== "true") {
              try {
                const statusRes = await getOnboardingStatus();
                if (statusRes && statusRes.success && statusRes.data) {
                  const completedStr = statusRes.data.onboarding_completed ? "true" : "false";
                  localStorage.setItem("onboarding_completed", completedStr);
                  setOnboardingCompleted(completedStr);
                }
              } catch (e) {
              }
            }
          }
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const roleId = localStorage.getItem("role_id");
  const isSuperAdmin = roleId === "7" || !!localStorage.getItem("superadmin");

  if (loading) {
    return null;
  }

  return (
    <Router fallback={<span />}>
      <Switch>
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/confirm-publisher" component={ConfirmPublisher} />
        {onboardingCompleted === "false" && !isSuperAdmin && (
          <Route path="/" exact component={StandalonePublisherOnboarding} />
        )}
        <Route path="/publisher-onboarding" exact component={StandalonePublisherOnboarding} />
        <Route component={DashboardLayout} />
      </Switch>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
    </Router>
  );
};

export default Layout;
